import { render } from "./SuggestCard.vue?vue&type=template&id=c3b3033c"
import script from "./SuggestCard.vue?vue&type=script&lang=js"
export * from "./SuggestCard.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__